<div class="content">
  <div class="texts">
    <h2>{{appname}}</h2>
    <h3>Naturally You. Beautifully Modern</h3>
    <!-- <a matRipple>Shop Now</a> -->
    <!-- <a routerLink="/about-us">Learn More</a> -->
  </div>
  <!-- <div class="products">
    <img src="/images/home/sweater/product1.webp" alt="product" />
    <img src="/images/home/sweater/product2.webp" alt="product" />
  </div> -->
</div>
